import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

//declarated component
import { EditDatafieldComponent } from './edit-datafield.component';

//internal modules
import { FocusDirectiveModule } from 'src/app/directives/focus-directive/focus-directive.module';
import { EditButtonModule } from 'src/app/views/shared/components/buttons/edit-button/edit-button.module';
import { SpinnerModule } from 'src/app/views/shared/components/spinner/spinner.module';



@NgModule({
  declarations: [
    EditDatafieldComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    //internal modules
    FocusDirectiveModule,
    EditButtonModule,
    SpinnerModule,
  ],
  exports: [
    EditDatafieldComponent
  ]
})
export class EditDatafieldModule { }
